import escapeHTML from 'cadenza/utils/escape-html';
import mark from 'cadenza/utils/mark';

export default str => mark(escapeHTML(str));
